import { STORE_NAMES } from '../constants/stores';
import {
  makeUseStoreHook,
  makeUseStoreHookName,
} from './hooksUtils';

export default Object.keys(STORE_NAMES).reduce((hooks, storeName) => {
  const hookName = makeUseStoreHookName(storeName);
  const hook = makeUseStoreHook(storeName);
  // eslint-disable-next-line no-param-reassign
  hooks[hookName] = hook;
  return hooks;
}, {});
